import { LoadingSpinner } from "@/components/ui/LoadingSpinner/LoadingSpinner";
import { Button } from "@/components/ui/shadcn/Button/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/shadcn/DropdownMenu/DropdownMenu";
import { EllipsisVertical, File, type LucideIcon } from "lucide-react";

export type RepoUploadSplitButtonOption = {
  label: string;
  icon: LucideIcon;
  onSelect: () => void;
  disabled?: boolean;
  testId?: string;
};

type RepoUploadSplitButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onUploadFile: () => void;
  options: RepoUploadSplitButtonOption[];
  label?: string;
  buttonIcon?: LucideIcon;
};

export function RepoUploadSplitButton({
  disabled = false,
  loading = false,
  onUploadFile,
  options,
  label = "Upload file",
  buttonIcon: ButtonIcon = File,
}: RepoUploadSplitButtonProps) {
  const isMenuDisabled = disabled || options.length === 0;

  return (
    <div className="flex items-center">
      <Button
        variant="outline"
        size="sm"
        className="rounded-r-none border-r-0"
        onClick={onUploadFile}
        type="button"
        disabled={disabled}
      >
        <ButtonIcon className="mr-2 h-4 w-4" />
        {label}
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild disabled={isMenuDisabled}>
          <Button
            variant="outline"
            className="rounded-l-none px-2"
            size="sm"
            title="Upload options"
            type="button"
            disabled={isMenuDisabled}
          >
            {loading ? (
              <LoadingSpinner />
            ) : (
              <EllipsisVertical className="h-4 w-4" />
            )}
            <span className="sr-only">Upload options</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {options.map((option) => {
            const Icon = option.icon;

            return (
              <DropdownMenuItem
                key={option.label}
                onClick={option.onSelect}
                disabled={option.disabled}
                data-testid={option.testId}
              >
                <Icon className="mr-2 h-4 w-4" />
                {option.label}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
